import React from 'react';

const NotfoundPage = () => {
    return <h2 className="my-5 text-center">Page not found</h2>;
}

export default NotfoundPage;